(function () {
  /* Update progress indicator given the leadform (parent of progress indicator)
     and history array of panels */
  const updateProgressIndicator = function ($leadformWrapper, previousPanels) {
    // Figure out which progress bar it is
    const progressWrapper = $leadformWrapper.find('.progress-wrapper--bar').length > 0 ? '.progress-wrapper--bar' : '.progress-wrapper--dots';
    const $progressWrapper = $leadformWrapper.find(progressWrapper);
    const totalSteps = $progressWrapper.data('total-steps');
    const $progressText = $progressWrapper.find('.progress__text');

    if( progressWrapper === '.progress-wrapper--bar' ) {
      const $progressBarIndicator = $progressWrapper.find('.progress-bar__indicator');
      // Width of indicator = % of steps user has completed
      const progressPercent = (previousPanels.length / totalSteps) * 100;

      // Update width inline
      $progressBarIndicator.css({width: `${ progressPercent }%`});

      // Update text
      if ($progressWrapper.hasClass('progress-wrapper--bar--wizard')) {
        $progressText.text(`Step ${ previousPanels.length } of ${ totalSteps }`);
      } else {
        $progressText.text(`${ previousPanels.length } of ${ totalSteps }`);
      }
    } else {
      // Each dot has a data-step attribute
      let currentDot = $progressWrapper.find(`.progress-dots__indicator[data-step=${ previousPanels.length }]`);
      // Move active class to currentDot
      $progressWrapper.find('.progress-dots__indicator--active').removeClass('progress-dots__indicator--active');
      currentDot.addClass('progress-dots__indicator--active');
      // Update text version of steps
      $progressText.text(`Step ${ previousPanels.length } of ${ totalSteps }`);
    }
  };

  /* Cycle through each leadform separately to handle multiple leadforms per page
     (otherwise progressing 1 leadform progresses them all) */
  const allLeadforms = $('.js-leadform');
  allLeadforms.each(function (i) {
    const $leadformWrapper = $(allLeadforms[i]);
    const $form = $leadformWrapper.find('form');
    const $questionPanels = $form.find('.lead-constructor__panel');
    const $nextButtons = $form.find('.js-lead-constructor__next');
    const $backButtons = $form.find('.js-lead-constructor__back');
    const $startingPanel = $questionPanels.filter('.active');
    const previousPanels = [];

    /* Focus cursor in first visible input on the given panel */
    const focusCursor = function ($panel) {
      if ($panel.hasClass('lead-constructor__form-fields')) {
        // Shame. This is a brittle condition that works for right now
        // The auto cursor focus caused rendering issues during animation (on the edge leadform)
        // `js-leadform--mini` is safe for now because the other forms that use this js have it,
        // but this should be cleaned up before we start it on more forms
        if ($leadformWrapper.hasClass('js-leadform--mini')) {
          $panel.find('input').first().focus();
        } else {
          $panel.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', function (e) {
            if (e.originalEvent.animationName == 'slide-in') {
              $panel.find('input').first().focus();
            }
          });
        }
      }
    };

    const goToPanel = function (targetPanelId, direction) {
      const $currentPanel = $questionPanels.filter('.active');
      const currentPanelId = $currentPanel.data('id');
      const $targetPanel = $questionPanels.filter(`[data-id=${ targetPanelId }]`);
      direction = direction || 'forward';

      // Update animation direction attribute so correct animations are used
      $leadformWrapper.attr('data-animation-direction', direction);

      if( direction == 'back' ) {
        // Remove active class, but don't mark as complete
        $currentPanel.removeClass('active');
        // Remove from previousPanels array
        previousPanels.pop(currentPanelId);
        // Remove completed class so content will actually show
        $targetPanel.removeClass('complete').addClass('active');
      } else if( $form.valid() ) { // Only progress forward if current step is valid
        // Remove active class on current panel and mark it as completed
        $currentPanel.removeClass('active').addClass('complete');
        // Add to previousPanels array now that it's complete
        previousPanels.push(currentPanelId);
        // Add active class to target panel
        $targetPanel.addClass('active');

        // Emit an event for consuming apps so they can do their unique things
        // format: 'mslf.name-panel.complete'
        const event = document.createEvent('Event');
        event.initEvent(`mslf.${ currentPanelId }.complete`, true, true);
        $leadformWrapper[0].dispatchEvent(event);
      }

      focusCursor($targetPanel);
      updateProgressIndicator($leadformWrapper, previousPanels);
    };

    const initialize = function () {
      // Add first panel to history array and update progress indicator
      previousPanels.push($startingPanel.data('id'));
      updateProgressIndicator($leadformWrapper, previousPanels);

      // NOTE: this can scroll the page to the leadform on page load!
      // Mini leadform is at the top of the page anyways, so this is safe on initialize
      if( $leadformWrapper.hasClass('js-leadform--mini') ) {
        focusCursor($startingPanel);
      }
    };

    // Bind events
    $nextButtons.on('click', function () {
      $leadformWrapper.addClass('interacted');
      goToPanel($(this).attr('data-target'));
    });

    $backButtons.on('click', function () {
      const prevPanel = previousPanels[previousPanels.length - 1];
      if( prevPanel == 'welcome' ) {
        $leadformWrapper.removeClass('interacted');
      }
      goToPanel(prevPanel, 'back');
    });

    initialize();
  });
})();
